// extracted by mini-css-extract-plugin
export default {"articleMain":"SectionCategoryVideo_articleMain__GXwLI","noSidePaddings":"SectionCategoryVideo_noSidePaddings__zg-QT","videoSection":"SectionCategoryVideo_videoSection__Mg0bn"};